import React, {useState} from "react";

// check for localstorage
const localStorageAvailable = () => {
    if (typeof(Storage) !== "undefined") {
        return true;
    }
    else {
        return false;
    }
}

export const TabBar = ({ activeTab, setActiveTab }) => {

    // show tooltip on first load only
    const [isTooltipOpen, setIsTooltipOpen] = 
        (localStorageAvailable()) ?
            (localStorage.getItem("JPMODShowDiscoverTooltip") == 'false') ? useState(false) : useState(true)
        :
        useState(true);

    const closeTooltip = () => {
        setIsTooltipOpen(false);
        localStorage.setItem("JPMODShowDiscoverTooltip","false");
    }

    const Tab = ({ tabName }) => {
        return (
            <label
                className='w-1/5 text-center cursor-pointer'
                href={`#${tabName}`}
                htmlFor={tabName}
                onClick={() => setActiveTab(tabName)}
            >
                <div
                    className={
                        activeTab === tabName
                            ? `bg-secondary rounded-full w-8 h-8 flex justify-center items-center m-auto`
                            : `bg-[#4f4f4f] rounded-full w-8 h-8 flex justify-center items-center m-auto`
                    }
                >
                    <img
                        src={`/assets/images/jpm-plus-icon-${tabName}.svg`}
                        width='20'
                        height='20'
                        className='text-center m-auto'
                    />
                </div>
                <span className='text-[12px] text-center text-[#e0e0e0] capitalize'>
          {tabName}
        </span>
            </label>
        );
    };

    return (
        <div
            className='fixed bottom-0 left-0 right-0 pt-2 pb-1 pl-3 pr-3 border-solid border-t border-[#7D7D7D]
            flex h-20 z-[1000] lg:z-auto items-center bg-[#242424]
            lg:relative lg:pl-2 lg:pr-2 lg:border-t-0 lg:w-full lg:justify-between lg:ml-0'
        >
            <div className='flex w-full justify-between'>
                <Tab tabName={'read'} />
                <Tab tabName={'prayer'} />
                {isTooltipOpen ? 
                    <div className={`tooltip-open w-1/5 tooltip tooltip-secondary text-bold tooltip-mobile-only`} 
                        data-tip="Check out more videos in the Discover tab"
                        onClick={() => {setActiveTab('discover'); closeTooltip();}}>
                        <Tab tabName={'discover'} onClick={() => closeTooltip()} />
                    </div>
                :
                    <Tab tabName={'discover'} />
                }
                <Tab tabName={'donate'} />
                <Tab tabName={'library'} />
            </div>
        </div>
    );
};